module.exports = __webpack_public_path__ + "img/09.46c8265b.png";